@if (hasEntitlements) {
  <div class="report-generator-container">
    <form [formGroup]="reportForm" #formDirective="ngForm" (submit)="submit(formDirective)" class='report-form'>
      <div class="form-field-container">
        <mat-form-field appearance="outline">
          <mat-label>Type</mat-label>
          <mat-select formControlName="reportType" (selectionChange)="updateSubLists(); reportSubmitted=false;" required>
            @for (type of reportTypeOptions; track type) {
              <mat-option [value]="type">{{type.reportType}}</mat-option>
            }
          </mat-select>
          @if (reportForm.controls['reportType'].errors?.required) {
            <mat-error>This field is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Format</mat-label>
          <mat-select formControlName="reportFormat" required>
            @for (format of reportFormatOptions; track format) {
              <mat-option [value]="format">{{format}}</mat-option>
            }
          </mat-select>
          @if (reportForm.controls['reportFormat'].errors?.required) {
            <mat-error>This field is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Report Cycle</mat-label>
          <mat-select formControlName="reportCycle" required>
            @for (cycle of reportCycleOptions; track cycle) {
              <mat-option [value]="cycle.reportCycle">{{cycle.display}}
              </mat-option>
            }
          </mat-select>
          @if (reportForm.controls['reportCycle'].errors?.required) {
            <mat-error>This field is required</mat-error>
          }
        </mat-form-field>
      </div>
      <div class='button-container'>
        @if (!isLoading) {
          <button type="submit" mat-raised-button color="primary"
          [disabled]="suppressSubmit || !reportForm?.valid" class="primary-btn">Create Report</button>
        }
        @if (isLoading) {
          <mat-spinner [diameter]="25"></mat-spinner>
        }
      </div>
    </form>
    @if (reportSubmitted) {
      <div class='submit-message-container'>
        <span class="material-symbols-outlined checkmark-icon">check_circle</span>
        <div class='submit-message'>
          Your request has been submitted. You will receive an email
          notifying you when it is ready to download from this site.
        </div>
      </div>
    }
  </div>
} @else {
  <div class="loading-container warning-message">
    {{ noEntitlementsMessage || 'Your currently selected agency does not have access to view Agency Reports. Try a
    different agency if available.'}}
  </div>
}

